export const EMAIL_ADDRESSES = {
    id: 'oe.complianceEmail.emailAddresses',
    description: 'Label text',
    defaultMessage: 'Email Addresses'
};
export const ENTER_COMA_SEPARATED_LIST_OF_IMAILS = {
    id: 'oe.emails.enterComaSeparatedListOfEmails',
    description: 'Label text',
    defaultMessage: 'Please enter a comma-separated list of email addresses.'
};
export const ALL_EMAILS_WILL_BE_BBCED = {
    id: 'oe.emails.allEmailsWillBeBbced',
    description: 'Label text',
    defaultMessage: `All emails sent from OE Passport will be bbc'ed to the email addresses entered above`
};
export const COMPLIANCE_EMAILS_STATUS_TEXT = {
    id: 'oe.accountAdmin.complianceEmailsStatus',
    description: 'Label text',
    message: 'Compliance Email Capture is {suffix}'
};
export const EMAIL_ADDRESSES_IS_REQUIRED = {
    id: 'oe.validation.email.required',
    defaultMessage: 'Email Addresses is required',
    description: 'Text label'
};
export const ENTER_MAXIMUM_TEN_EMAILS = {
    id: 'oe.validation.email.mustBeMaxTenEmails',
    defaultMessage: 'Please, enter maximum 10 emails',
    description: 'Text label'
};
export const COMPLIANCE_EMAIL_DATA_UPDATED = {
    id: 'oe.accountAdmin.complianceEmailsStatusUpdated',
    description: 'Notification text',
    defaultMessage: 'Compliance Email Capture Data updated'
};